import { Navigation } from '@/components/portfolio/Navigation';
import { Hero } from '@/components/portfolio/Hero';
import { About } from '@/components/portfolio/About';
import { Experience } from '@/components/portfolio/Experience';
import { Education } from '@/components/portfolio/Education';
import { Skills } from '@/components/portfolio/Skills';
import { Projects } from '@/components/portfolio/Projects';
import { Contact } from '@/components/portfolio/Contact';
import { BlogPreview } from '@/components/portfolio/BlogPreview';
import { VideoPreview } from '@/components/portfolio/VideoPreview';
import { Footer } from '@/components/portfolio/Footer';
import { Seo, SITE_URL } from '@/components/seo/Seo';
import { Book } from '@/components/portfolio/Book';

const bookSchema = {
  '@context': 'https://schema.org',
  '@type': 'Book',
  name: 'From International Doctor to NHS Clinician: The IMG2NHS Pathway Guidebook',
  bookEdition: '2026/27 Edition',
  bookFormat: 'https://schema.org/EBook',
  inLanguage: 'en-GB',
  author: { '@type': 'Person', name: 'Dr. Yesh Jitesh', url: SITE_URL },
  publisher: { '@type': 'Organization', name: 'IMG2NHS', url: 'https://img2nhs.com' },
  url: 'https://img2nhs.com/ebook',
};

const personSchema = {
  '@context': 'https://schema.org',
  '@type': 'Person',
  name: 'Dr. Yesh Jitesh',
  jobTitle: 'GP Assistant, Clinical Administrator & Medical Coder',
  description:
    'Clinician and healthcare innovator combining hands-on patient care with technology-driven solutions. Founder of RotaCare.uk and IMG2NHS.com',
  url: SITE_URL,
  address: { '@type': 'PostalAddress', addressLocality: 'London', addressCountry: 'GB' },
  sameAs: ['https://www.linkedin.com/in/dryeshjitesh', 'https://rotacare.uk', 'https://img2nhs.com'],
  knowsAbout: [
    'General Practice',
    'Clinical Coding',
    'SNOMED CT',
    'EMIS Web',
    'QOF Audits',
    'Chronic Disease Management',
    'Spirometry',
    'ABPM',
    'Healthcare Administration',
    'HealthTech',
  ],
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Dr. Yesh Jitesh',
  url: SITE_URL,
  inLanguage: 'en-GB',
  publisher: { '@type': 'Person', name: 'Dr. Yesh Jitesh' },
};

const Index = () => {
  return (
    <div className="w-full">
      <Seo
        title="Dr. Yesh Jitesh | NHS GP Assistant, Medical Coder & HealthTech Founder"
        description="Dr. Yesh Jitesh — NHS GP Assistant, clinical administrator and medical coder in London. EMIS Web, QOF audits, SNOMED CT coding and chronic disease reviews. Founder of RotaCare.uk and IMG2NHS.com."
        path="/"
        type="profile"
        keywords="Dr Yesh Jitesh, NHS GP Assistant, Medical Coder London, EMIS Web, QOF Audit, SNOMED CT, Clinical Administrator, RotaCare UK, IMG2NHS, HealthTech founder"
        imageAlt="Dr. Yesh Jitesh — GP Assistant & Healthcare Professional"
        jsonLd={[personSchema, websiteSchema, bookSchema]}
      />
      <Navigation />
      <main>
        <Hero />
        <About />
        <Experience />
        <Education />
        <Skills />
        <Projects />
        <Book />
        <BlogPreview />
        <VideoPreview />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
